export const CANNOT_CREATE_COUPON = 'coupons/CANNOT_CREATE_COUPON';
